import React, { useEffect, useState } from "react";
import { ChatLink } from "tsi-common-react/src/apps/chat/ChatLink";
import { getChatConnector } from "tsi-common-react/src/apps/chat/index";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import badgeChatWhite from "../../svg/badge-chat-white.png";

export const ChatCard = (): React.ReactNode => {
    const [isChatOnline, setIsChatOnline] = useState(false);
    const contactUsFormURL = usePageURL("contact_us_form");
    const homeURL = usePageURL("home");

    useEffect(() => {
        (async () => {
            const { isOnline } = await getChatConnector().init();
            setIsChatOnline(isOnline);
        })();
    }, []);

    if (!isChatOnline) {
        return null;
    }

    return (
        <>
            <img src={badgeChatWhite} alt="" />
            <h3>
                <strong>{t`Chat`}</strong>
            </h3>
            <p>
                {t`Questions about our products or need advice before you buy? Chat with one of our specialists.`}
            </p>
            <ChatLink
                chatOnlineText={t`Chat`}
                chatOfflineLink={contactUsFormURL || homeURL}
            />
        </>
    );
};
